// extracted by mini-css-extract-plugin
export default {"Paginator":"Paginator_Paginator__NdCI+","paginateButton":"Paginator_paginateButton__10Nyl"};